import LocalForage from 'localforage'
export default {
    UPDATE_USERS (state, results){
        update_list(state.users, results);
    },
    CHANGE_LANGAGE(state, newLangage) {
        state.currentLanguage = newLangage;
    },
    SET_SELECTED_FACTORY(state, selectedFactory){
        state.selectedFactory = selectedFactory;
    },
    SET_IMPORTABLE_DATA(state, importableData){
        state.importableMotorData = importableData;
    },
    CLEAR_IMPORTABLE_DATA(state, importableData){
        state.importableMotorData = null;
    }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js